import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {Auth, sendPasswordResetEmail} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  http: HttpClient = inject(HttpClient);
  auth = inject(Auth);
  user: any;
  userSignal: WritableSignal<any> = signal({});
  constructor() {
    this.auth.onAuthStateChanged(async (user) => {
      if (user && !this.user) {
        console.log(this.user);
        await this.getUser();
      }
    });
  }

  register(user: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiUrl}/user/register`, user)
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  updateUser(id: string, user: any) {
    return new Promise((resolve, reject) => {
      this.http.patch(`${environment.apiUrl}/user/${id}`, user)
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  async updateWishlist(propertyId: any) {
    const wishlist: any = [];
    wishlist.push(propertyId);
    if (!this.auth.currentUser) {
      this.router.navigate(['/user/login']);
      return;
    }
    return new Promise((resolve, reject) => {
      this.http.patch(`${environment.apiUrl}/user/${this.user._id}/wishlist`, {wishlist})
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  async isInWishList(propertyId: string, userId: string) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/user/${userId}/wishlist/${propertyId}`, {})
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  async getWishlist() {
    if (!this.user) {
      return ;
    }
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/user/${this.user._id}/wishlist`, {})
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  findUser(email: string) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/user/${email}`)
        .subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
    });
  }

  sedPasswordResetEmail(email: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiUrl}/auth/forgot-password`, { email })
        .subscribe({
          next: (res: any) => {
            console.log(res);
            if (res.status === 200) {
              sendPasswordResetEmail(this.auth, email)
                .then(() => {
                  resolve(true);
                })
                .catch(err => {
                  reject(err);
                });
            } else {
              reject(res.response);
            }
          },
          error: err => reject(err)
        })
    });
  }
  router: Router = inject(Router);
  async login(body: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiUrl}/auth/login`, body)
        .subscribe({
          next: async (res: any) => {
            console.log(res.access_token);
            await this.getUser();
            // console.log(res)
            resolve(res);
          },
          error: err => {
            reject(err);
          }
        });
    })
  }
//   userResource = httpResource<any>({
//     url: `${environment.apiUrl}/auth/me`,
//     headers: new HttpHeaders({
//       'Authorization': `Bearer ${token}`
//     })
// });
//   userData = computed(() => this.userResource.value() ?? {});
//   userDataError = computed(() => this.userResource.error());

  getUser() {
    return new Promise(async (resolve, reject) => {
      const token = await this.auth.currentUser?.getIdToken();
      const header = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      if (!token) {
        resolve(false);
        return;
      }
      this.http.get(`${environment.apiUrl}/auth/me`, {headers: header})
        .subscribe({
          next: (res: any) => {
            this.user = res;
            this.userSignal.set(res);
            resolve(res)
          },
          error: err => reject(err)
        })
    });
  }
  // private countryListResource = httpResource<eSimCountryResponse>(`${this.urlService.webServiceUrl() + environment.methods.eSim}esimcountry&returnformat=json`);
  // countryList = computed(() => this.countryListResource.value()?.Result ?? [] as eSimCountry[]);
  // countryListError = computed(() => this.countryListResource.error() as HttpErrorResponse);
  // countryListErrorMessage = setErrorMessage(this.countryListError(), 'Country List');
  // countryListIsLoading = this.countryListResource.isLoading;
}
export interface User {

}
